export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CONTACT = {
  email: "support.amberbrewteam@gmail.com",
  phoneDisplay: "+91 78140 40128",
  phoneRaw: "+917814040128",
  hours: "Mon – Sat · 10:00 – 19:00 IST",
  domain: "www.amberbrewtea.com",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1612846213933-916a1f56d859?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbW9vZHklMjB0ZWElMjBwaG90b2dyYXBoeXxlbnwwfHx8fDE3ODgwMDY5MjB8MA&ixlib=rb-4.1.0&q=85",
  leaves:
    "https://images.unsplash.com/photo-1604697976842-d36fa5a1b2ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwbG9vc2UlMjBsZWFmJTIwdGVhfGVufDB8fHx8MTc4ODAwNjkyMHww&ixlib=rb-4.1.0&q=85",
  plantation:
    "https://images.unsplash.com/photo-1563514227147-6d2ff665a6a0?q=80&w=1600&auto=format&fit=crop",
  pour: "https://images.unsplash.com/photo-1558160074-4d7d8bdf4256?q=80&w=1600&auto=format&fit=crop",
  spoons:
    "https://images.unsplash.com/photo-1563822249366-3efb23b8e0c9?q=80&w=1600&auto=format&fit=crop",
};

export const FALLBACK_PRODUCTS = [
  {
    slug: "darjeeling-first-flush",
    range: "classic",
    name: "Darjeeling First Flush",
    price: 649,
    unit: "1 kg pouch",
    tag: "Single Estate",
    notes: "Muscatel · Floral · Bright",
    description:
      "The champagne of teas, plucked at first flush in the high gardens of Darjeeling.",
    image: "/images/products/darjeeling-first-flush.png",
  },
  {
    slug: "assam-golden-tips",
    range: "classic",
    name: "Assam Golden Tips",
    price: 399,
    unit: "1 kg pouch",
    tag: "Breakfast",
    notes: "Malty · Bold · Honeyed",
    description: "A deep, malty cup from the Brahmaputra valley — built for slow mornings.",
    image: "/images/products/assam-golden-tips.png",
  },
  {
    slug: "blue-label-reserve",
    range: "classic",
    name: "Blue Label Reserve",
    price: 849,
    unit: "1 kg caddy",
    tag: "House Reserve",
    notes: "Velvet · Cocoa · Long Finish",
    description: "Our master blenders' reserve — whole-leaf, velvet-bodied, quietly luxurious.",
    image: "/images/products/blue-label-reserve.png",
  },
  {
    slug: "black-label-smoked",
    range: "classic",
    name: "Black Label Smoked",
    price: 849,
    unit: "1 kg pouch",
    tag: "Limited",
    notes: "Smoky · Dark Amber · Full Body",
    description: "Slow-smoked over pinewood embers. Pours the colour of dark amber glass.",
    image: "/images/products/black-label-smoked.png",
  },
  {
    slug: "masala-chai",
    range: "classic",
    name: "Masala Chai",
    price: 599,
    unit: "1 kg pouch",
    tag: "Bestseller",
    notes: "Cardamom · Ginger · Warm Spice",
    description: "Stone-ground spices folded into strong Assam leaf. Made for milk and rain.",
    image: "/images/products/masala-chai.png",
  },
  {
    slug: "mint-tea",
    range: "classic",
    name: "Mint Tea",
    price: 349,
    unit: "1 kg pouch",
    tag: "Caffeine-Light",
    notes: "Cooling · Clean · Garden Fresh",
    description: "Cool green leaf lifted with fresh-cut mint. Clears the head, calms the hour.",
    image: "/images/products/mint-tea.png",
  },
  {
    slug: "rose-tea",
    range: "classic",
    name: "Rose Tea",
    price: 849,
    unit: "1 kg pouch",
    tag: "Floral",
    notes: "Petal Soft · Perfumed · Silky",
    description: "Hand-blended with damask rose petals — a soft, perfumed, silk-textured cup.",
    image: "/images/products/rose-tea.png",
  },
  {
    slug: "hibiscus-tea",
    range: "classic",
    name: "Hibiscus Tea",
    price: 849,
    unit: "1 kg pouch",
    tag: "Caffeine-Free",
    notes: "Crimson · Tart · Ruby Pour",
    description: "Sun-dried hibiscus petals that pour ruby-red. Bright, tart, endlessly sippable.",
    image: "/images/products/hibiscus-tea.png",
  },
  {
    slug: "herbal-green-tea",
    range: "wellness",
    name: "Herbal Green Tea",
    price: 649,
    unit: "1 kg pouch",
    tag: "Wellness",
    notes: "Herbal · Mellow · Clean Finish",
    description: "Organic herbs and whole green leaves in a calm, zen-like cup.",
    image: "/images/products/herbal-green-tea.png",
  },
  {
    slug: "special-turmeric-tea",
    range: "wellness",
    name: "Special Turmeric Tea",
    price: 449,
    unit: "1 kg pouch",
    tag: "Wellness",
    notes: "Golden · Warming · Honeyed",
    description: "Bright golden turmeric root blended for a warm, healthy glow in every mug.",
    image: "/images/products/special-turmeric-tea.png",
  },
  {
    slug: "laung-tulsi-special",
    range: "wellness",
    name: "Laung Tulsi Special",
    price: 449,
    unit: "1 kg pouch",
    tag: "Ayurvedic",
    notes: "Clove Spice · Basil Fresh · Soothing",
    description: "Fresh Tulsi leaves and whole cloves — an earthy, soothing herbal blend.",
    image: "/images/products/laung-tulsi-special.png",
  },
  {
    slug: "ayurvedic-tea",
    range: "wellness",
    name: "Ayurvedic Tea",
    price: 1149,
    unit: "1 kg caddy",
    tag: "Premium Wellness",
    notes: "Ancient Herbs · Restorative · Rich",
    description: "A holistic premium blend of ancient Ayurvedic herbs, roots and leaves.",
    image: "/images/products/ayurvedic-tea.png",
  },
];

export const CHAPTERS = [
  {
    number: "01",
    title: "The Leaf",
    image: IMAGES.plantation,
    alt: "Tea garden rows under a wide sky",
    body: "Every Amber Brew tea begins in a single garden — the misted slopes of Darjeeling, the low, humid plains of Assam. We buy leaf the slow way: from growers we know by name, in lots small enough to taste individually.",
  },
  {
    number: "02",
    title: "The Fire",
    image: IMAGES.leaves,
    alt: "Loose tea leaves, close and earthy",
    body: "Withering, rolling, firing — the leaf is transformed by heat and patience, never haste. Our blends rest for weeks before they are sealed, so what reaches your cup has already settled into itself.",
  },
  {
    number: "03",
    title: "The Pour",
    image: IMAGES.pour,
    alt: "Tea being poured beside a clay teapot",
    body: "Three leaves on amber — our mark is a promise: garden, fire, and your table. A tea is only finished when it is poured. We make the leaf; you complete the ritual.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "The Darjeeling First Flush is the finest cup I have had outside the estate itself. You can taste the altitude.",
    name: "Meera Kulkarni",
    place: "Pune",
  },
  {
    quote:
      "Blue Label Reserve turned my evening chai into a small ceremony. Velvet-smooth, not a trace of bitterness.",
    name: "Arjun Bhandari",
    place: "Jaipur",
  },
  {
    quote:
      "I ordered the Hibiscus on a whim — it pours like a ruby and tastes like late summer. Now it is a weekly ritual.",
    name: "Sana Qureshi",
    place: "Mumbai",
  },
];

export const BREW_STEPS = [
  {
    number: "01",
    title: "Heat",
    body: "Fresh water, just off the boil for black teas — cooler, near 80°C, for green.",
  },
  {
    number: "02",
    title: "Steep",
    body: "One heaped spoon per cup. Cover the pot and let the leaf open without disturbance.",
  },
  {
    number: "03",
    title: "Pour",
    body: "Strain, pour low, and let the cup sit a breath before the first sip.",
  },
];

export const BREW_SPECS = [
  { tea: "Darjeeling First Flush", temp: "85°C", time: "3 min" },
  { tea: "Assam Golden Tips", temp: "95°C", time: "4 min" },
  { tea: "Blue Label Reserve", temp: "90°C", time: "4 min" },
  { tea: "Masala Chai", temp: "100°C", time: "5 min, with milk" },
  { tea: "Herbal Green Tea", temp: "78°C", time: "2 min" },
  { tea: "Hibiscus Tea", temp: "95°C", time: "6 min" },
  { tea: "Special Turmeric Tea", temp: "90°C", time: "5 min" },
  { tea: "Laung Tulsi Special", temp: "95°C", time: "5 min" },
  { tea: "Ayurvedic Tea", temp: "90°C", time: "6 min" },
];
